import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/dsr",
  component: RouteComponent,
  children: [
    {
      path: "",
      name: "dsr.index",
      component: () =>
        import(
          /* webpackChunkName: "dsr-list" */ "@/views/dsr/DsrListView.vue"
        ),
      props: true,
      meta: {
        title: "dsr-list",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "create",
      name: "dsr.create",
      component: () =>
        import(
          /* webpackChunkName: "dsr-create" */ "@/views/dsr/DsrCreate.vue"
        ),
      props: (route) => ({
        dsrName: route.query.dsrName,
        enterpriseId: route.query.enterpriseId,
        dsrYear: route.query.dsrYear,
        dsrType: route.query.dsrType,
      }),
      meta: {
        title: "dsr-create",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
        container: {
          fillHeight: true,
        },
      },
    },
    {
      path: "compare",
      name: "dsr.compare",
      component: () =>
        import(
          /* webpackChunkName: "dsr-compare" */ "@/views/dsr/DsrCompareView.vue"
        ),
      props: (route) => ({
        preselectedId: route.query.dsrId
          ? Number(route.query.dsrId)
          : undefined,
      }),
      meta: {
        title: "dsr-compare",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
        container: {
          fillHeight: true,
        },
        fullScreen: { show: true },
      },
    },
    {
      path: ":id(\\d+)",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "dsr.show",
          component: () =>
            import(
              /* webpackChunkName: "dsr-view" */ "@/views/dsr/DsrView.vue"
            ),
          props: true,
          meta: {
            title: "dsr.default",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
            container: {
              fillHeight: true,
            },
            fullScreen: { show: true },
          },
        },
        {
          path: "info",
          name: "dsr.info.index",
          component: () =>
            import(
              /* webpackChunkName: "dsr-info-index" */ "@/views/dsr/DsrInfoView.vue"
            ),
          props: true,
          meta: {
            title: "dsr-info-page-title",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
          },
        },
        {
          path: "dashboard",
          name: "dsr.dashboard",
          component: () =>
            import(
              /* webpackChunkName: "dsr-dashboard" */ "@/views/dsr/DsrDashboardView.vue"
            ),
          props: true,
          meta: {
            title: "dsr-dashboard-title",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
            container: {
              fillHeight: true,
            },
            fullScreen: { show: true },
          },
        },
        {
          path: "facilities",
          component: RouteComponent,
          children: [
            {
              path: "add",
              name: "dsr.facilities.add",
              component: () =>
                import(
                  /* webpackChunkName: "dsr-facilities-add" */ "@/views/dsr/DsrAddFacility.vue"
                ),
              props: true,
              meta: {
                title: "dsr-facilities-add-title",
                header: { show: true },
                navbar: { show: true },
                footer: { show: true },
                container: {
                  fillHeight: true,
                },
              },
            },
          ],
        },
        {
          path: "documents",
          component: RouteComponent,
          children: [
            {
              path: "bulk-upload",
              name: "dsr.documents.bulk-upload",
              component: () =>
                import(
                  /* webpackChunkName: "dsr-documents-bulk-upload" */ "@/views/dsr/DsrDocumentsBulkUploadView.vue"
                ),
              props: true,
              meta: {
                title: "dsr-documents-bulk-upload-title",
                header: { show: true },
                navbar: { show: true },
                footer: { show: true },
                container: {
                  fillHeight: true,
                },
              },
            },
            {
              path: "bulk-review",
              name: "dsr.documents.bulk-review",
              component: () =>
                import(
                  /* webpackChunkName: "dsr-documents-bulk-review" */ "@/views/dsr/DsrDocumentsBulkReviewView.vue"
                ),
              props: true,
              meta: {
                title: "dsr-documents-bulk-review-title",
                header: { show: true },
                navbar: { show: true },
                footer: { show: true },
                container: {
                  fillHeight: true,
                },
              },
            },
          ],
        },
      ],
    },
  ],
};
